const config = {
  lv: {
    bookm_item: {
      cancel: 'Atcelt',
      confirm_del: 'Apstiprināt dzēšanu',
      delete: 'Dzēst',
      rename: 'Pārsaukt',
      save: 'Saglabāt',
    },
    bookm_panel: {
      go: 'Aiziet',
      less: 'Mazāk',
      more: 'Vairāk',
      new_name: 'Gramatzīme',
    },
    layer_panel: {
      details: 'Vairāk info',
      hidden: 'Izslēgts',
      visible: 'Ieslēgts',
      less: 'Mazāk',
      more: 'Vairāk',
      legend: 'Leģenda',
      project: 'Projekts',
    },
    layer_desc: {
      '05_plavas': 'Latvijas Dabas fonda "Dabisko pļavu produkts" zīmola ražotāji',
      '10_kult': 'Aizsargājamo kultūras pieminekļu reģistrs, datus publicēja Nacionālā kultūras mantojuma pārvalde.',
      '15_melioracijas': 'Meliorācijas sistēmu informācija no “Zemkopības ministrijas nekustamie īpašumi” (ZMNĪ) meliorācijas kadastra: drenu sistēmas, grāvji, kolektori, hidrotehniskās būves, polderi un valsts nozīmes ūdensnotekas. Datus publicēja ZMNĪ (INSPIRE pakalpe ĢeoLatvija portālā).',
      '16_ozols': 'Dabas datu pārvaldības sistēma "Ozols", datus publicēja Dabas aizsardzības pārvalde.',

      "20_nai_grupas": "Vidējais pieejamais teorētiskais dūņu daudzums NAI ar 1% sausnas, t/gadā. Šis rādītājs ir vidējā vērtība no 2017., 2018. un 2019. gadā novērotajām dūņu daudzumu vērtībām.",

      '171_dunu_komposts_2025': 'Lauki, kuros atļauta vai aizliegta notekūdeņu dūņu komposta iestrāde (2025). A, B, C un D grupu notekūdeņu attīrīšanas iekārtas (NAI) un vidējais teorētiski pieejamais NAI dūņu daudzums ar 1% sausnas, t/gadā (vidēji par 2017.–2019. g.). LIFE18 IPE /LV/000014 (LIFE GOODWATER IP).',
      '172_dunu_komposts_2024': 'Lauki, kuros atļauta vai aizliegta notekūdeņu dūņu komposta iestrāde (2024). A, B, C un D grupu notekūdeņu attīrīšanas iekārtas (NAI) un vidējais teorētiski pieejamais NAI dūņu daudzums ar 1% sausnas, t/gadā (vidēji par 2017.–2019. g.). LIFE18 IPE /LV/000014 (LIFE GOODWATER IP).',

      '18_eko4_2024': 'Samazinātā augsnes apstrāde / Reduced soil tillage - 2024',
      '19_eko4_2023': 'Samazinātā augsnes apstrāde / Reduced soil tillage - 2023',

      '21_lad_bloki': 'Lauku bloku informācija, datus publicēja Lauku atbalsta dienests.',
      '22_lad_lauki': 'Deklarēto lauku informācija, datus publicēja Lauku atbalsta dienests.',
      
      '24_water_bodies': 'Ūdensteces un ūdenstilpnes',
      '25_soil_group': 'Vēsturiskās augsnes, augšņu grupas. Datus publicēja VAAD.',
      '26_soil_contents': 'Vēsturiskās augsnes, augšņu cilmiežu sastāvs. Datus publicēja VAAD.',
      '27_soil_value': 'Augsnes klašu un vērtības karte, klasifikācija detalizēti aprakstīta šeit:',
      '28_dtw_malains': 'Depth-to-water gruntsūdeņu modelis 10 ha sateces baseina slieksnim (mālainiem nogulumiem), © Latvijas Valsts mežzinātnes institūts "Silava", Interreg Baltijas jūras reģiona programmas projekts WAMBAF Tool Box (#X007), LIFE programmas pētījums "Klimata pārmaiņu samazināšanas iespēju demonstrēšana auglīgās organiskajās augsnēs Baltijas valstīs un Somijā" (LIFE OrgBalt, LIFE18 CCM/LV/001158). Datus publicēja Latvijas Valsts mežzinātnes institūts "Silava".',
      '29_dtw_smilsains': 'Depth-to-water gruntsūdeņu modelis 30 ha sateces baseina slieksnim (smilšainiem nogulumiem), © Latvijas Valsts mežzinātnes institūts "Silava", Interreg Baltijas jūras reģiona programmas projekts WAMBAF Tool Box (#X007), LIFE programmas pētījums "Klimata pārmaiņu samazināšanas iespēju demonstrēšana auglīgās organiskajās augsnēs Baltijas valstīs un Somijā" (LIFE OrgBalt, LIFE18 CCM/LV/001158). Datus publicēja Latvijas Valsts mežzinātnes institūts "Silava".',
      '30_dtw_lvm': 'Gruntsūdeņu modelis (angl. depth-to-water) 10 ha sateces baseina slieksnim (mālainiem nogulumiem). Virszemes noteces modelēšanai izmantoti LVM un ZMNI meliorācijas dati. Datus publicēja AS "Latvijas valsts meži" (LVM GEO).',
      '31_cadastre': 'Kadastra karte – zemes vienības ar kadastra apzīmējumiem, servisu publicēja AS "Latvijas valsts meži", izmantojot Valsts zemes dienesta datus. Slānis ir redzams, tuvinot karti (mērogā, sākot no 1:50000).',
      // '31_admin': 'Administrative border map, published by State Land Service.',
      
      '40_meteo_temp': 'Laiks (gaisa temperatūra) uz esošo brīdi',
      '41_meteo_precip': 'Laiks (nokrišņi) uz esošo brīdi',
      '89_s2_meta': 'Metadati krāsainas satelītbilžu mozaīkai, kas balstās uz Eiropas Kosmosa aģentūras (ESA) Sentinel-2 satelīta uzņēmumiem, datus apstrādāja un rezultātu publicēja SIA "Baltic Satellite Service".',
      '90_s2_rgb': 'Krāsaina satelītbilžu mozaīka, kas balstās uz Eiropas Kosmosa aģentūras (ESA) Sentinel-2 satelīta uzņēmumiem, datus apstrādāja un rezultātu publicēja SIA "Baltic Satellite Service".',
      '91_s2_nirrg': 'Infrasarkana satelītbilžu mozaīka, kas balstās uz Eiropas Kosmosa aģentūras (ESA) Sentinel-2 satelīta uzņēmumiem, datus apstrādāja un rezultātu publicēja SIA "Baltic Satellite Service".',
      '92_s2_ndvi': 'NDVI satelītbilžu mozaīka, kas balstās uz Eiropas Kosmosa aģentūras (ESA) Sentinel-2 satelīta uzņēmumiem, datus apstrādāja un rezultātu publicēja SIA "Baltic Satellite Service".',
      '93_s2_msavi2': 'MSAVI2 satelītbilžu mozaīka, kas balstās uz Eiropas Kosmosa aģentūras (ESA) Sentinel-2 satelīta uzņēmumiem, datus apstrādāja un rezultātu publicēja SIA "Baltic Satellite Service".',
      '95_ortho_rgb': 'Krāsainais ortofoto no Latvijas Ģeotelpiskās informācijas aģentūras datiem (uzņemts laika periodā no 2019. gada līdz 2021. gadam), datus apstrādāja un rezultātu publicēja AS "Latvijas valsts meži".',
      '96_ortho_ir': 'Infrasarkanais ortofoto no Latvijas Ģeotelpiskās informācijas aģentūras datiem (uzņemts laika periodā no 2019. gada līdz 2021. gadam), datus apstrādāja un rezultātu publicēja AS "Latvijas valsts meži".',
      '98_dtm': 'Digitālais reljefa modelis Baltijas valstīm, datus apstrādāja un rezultātu publicēja Forest Radar.',
      '99_osm': 'Topografiskā karte no OpenStreetMap datiem, publicēja Mapbox.',
    },
    layer_name: {
      '05_plavas': 'Dabisko pļavu produkta ražotāji',
      '10_kult': 'Kultūras pieminekļi',
      '15_melioracijas': 'Meliorācijas sistēmas',
      '16_ozols': 'Dabas aizsardzība',

      '20_nai_grupas':  "A, B, C un D grupu notekūdeņu attīrīšanas iekārtas (NAI)",

      '171_dunu_komposts_2025': 'Lauki, kuros atļauta vai aizliegta notekūdeņu dūņu komposta iestrāde (2025)',
      '172_dunu_komposts_2024': 'Lauki, kuros atļauta vai aizliegta notekūdeņu dūņu komposta iestrāde (2024)',

      '18_eko4_2024': 'Samazinātā augsnes apstrāde (2024)',
      '19_eko4_2023': 'Samazinātā augsnes apstrāde (2023)',
      
      '21_lad_bloki': 'LAD Lauku bloki',
      '22_lad_lauki': 'LAD Deklarētie lauki',
      
      '24_water_bodies': 'Ūdensteces un ūdenstilpnes',
      '25_soil_group': 'Augšņu grupas',
      '26_soil_contents': 'Augšņu cilmiežu sastāvs',
      '27_soil_value': 'Augšņu klases un vērtība',
      '28_dtw_malains': 'Gruntsūdeņu modelis mālainiem nogulumiem',
      '29_dtw_smilsains': 'Gruntsūdeņu modelis smilšainiem nogulumiem',
      '30_dtw_lvm': 'Gruntsūdeņu modelis (LVM)',
      '31_cadastre': 'Kadastrs',
      // '31_admin': 'Administrative division',
      
      '40_meteo_temp': 'Laiks (gaisa temperatūra)',
      '41_meteo_precip': 'Laiks (nokrišņi)',
      '89_s2_meta': 'Satelītkartes metadati',
      '90_s2_rgb': 'Satelītkarte',
      '91_s2_nirrg': 'Satelītkarte (infrasarkana)',
      '92_s2_ndvi': 'Satelītkarte (NDVI)',
      '93_s2_msavi2': 'Satelītkarte (MSAVI2)',
      '95_ortho_rgb': 'Ortofoto (krāsains)',
      '96_ortho_ir': 'Ortofoto (infrasarkanais)',
      '98_dtm': 'Reljefs',
      '99_osm': 'Topokarte',
    },
    nav_panel: {
      appname: 'Zemnieku Saeima',
      bookmarks: 'Gramatzīmes',
      layers: 'Slāņi',
      login_no_break: '<strong>Ienākt</strong>&nbsp;vai <strong>Izveidot&nbsp;kontu</strong>',
      login_with_break: '<strong>Ienākt</strong> vai<br><strong>Izveidot kontu</strong>',
      plots: 'Lauki',
      profile: 'Profils',
    },
    panel_buttons: {
      add_bookmark: 'Pievienot jaunu gramatzīmi',
      login: '<strong>Ieet</strong> vai <strong>Izveidot kontu</strong>',
      logout: 'Iziet',
      upload_start: 'Importēt laukus (Esri Shapefile, .shp)',
    },
    pagination: {
      first_page: '⇤',
      last_page: '⇥',
      next_page: '→',
      page_number: 'Lapa',
      prev_page: '←',
    },
    plot_buttons: {
      cancel: 'Atcelt',
      login_signup: 'Lūdzu, ieejiet vai izveidojiet kontu lai lietot šo funkcionalitāti',
      save: 'Saglabāt',
      start: 'Uzzīmēt jaunu lauku',
    },
    plot_item: {
      cancel: 'Atcelt',
      confirm_del: 'Apstiprināt dzēšanu',
      delete: 'Dzēst',
      edit: 'Rediģēt',
      save: 'Saglabāt',
    },
    plot_attrs: {
      apaksnog: 'Apakšnogabals',
      area_ha: 'Platība',
      area_units: 'ha',
      atslega: 'Atslēga',
      cad_info: 'Kadastra info',
      cad_nr: 'Kadastra apzīmējums',
      ext_id: 'Kompānijas ID',
      ext_info: 'Kompānijas info',
      kadnum: 'Kadastra numurs',
      kopkraja: 'Kopkrāja',
      kvartals: 'Kvartāls',
      mon_date: 'Noteikšanas datums',
      mon_info: 'Monitoringa info',
      mon_result: 'Noteikts zemes lietošanas veids',
      mon_status: 'Monitoringa status',
      mon_val_forest: 'Forest (70-100% forest)',
      mon_val_no_forest: 'Clearcut (0-30% forest)',
      mon_val_no_value: 'Monitoring not peformed yet',
      mon_val_other: 'Other (30-70% forest)',
      mon_val_clearcut: 'Clearcut detected',
      mon_val_no_change: 'No change detected',
      mon_val_unknown: 'Not enough data available',
      mon_val_windfall: 'Possible windfall detected',
      no_value: '[Nav vērtības]',
      reg_id: 'LAD ID',
      reg_info: 'LAD info',
    },
    plot_panel: {
      go: 'Aiziet',
      less: 'Mazāk', //⌃↥⬏
      more: 'Vairāk', //⌄↴↧⬎
      new_name: 'Lauks',
    },
    prof_item: {
      admin_true: 'Jā',
      admin_false: 'Nē',
    },
    prof_mon_freq: {
      disabled: 'Netiek ziņots',
      quarter: 'Reizi ceturksnī',
      month: 'Reizi mēnesī',
      week: 'Reizi nedēļā',
    },
    prof_panel: {
      comp_admin: 'Kompānijas menedžeris',
      comp_name: 'Kompānija',
      edit_cancel: 'Atcelt',
      edit_profile: 'Rediģēt profilu',
      edit_save: 'Saglabāt izmaiņas',
      email: 'Epasts',
      full_name: 'Vārds un uzvārds',
      logged_out: 'Izgājis no konta',
      mon_freq: 'Ziņošana par jaunām satelītbildēm',
      phone: 'Telefons',
    },
    search: {
      placeholder: 'Ievadiet adresi, LAD numuru vai ģeogrāfiskās koordinātes',
    },
    upload: {
      started: 'Augšupielāde uzsākta',
      progress: 'Augšupielādēts',
      success: 'Augšupielāde pabeigta, Sākta apstrāde. Lūdzu, atjaunojiet web pārlūka lapu (nospiediet F5 pogu uz klaviatūras) pēc 30 sekundēm',
      failure_size: 'Augšupielāde nav izdevies, faila izmērs ir kļūdains',
      failure_type: 'Augšupielāde nav izdevies, fails nav ZIP arhīvs',
      failure_unknown: 'Augšupielāde nav izdevies, iemesls nav zināms',
    },
  },
};
export default config;
